const types = {
	novostnik: 'novostnik',
	campaign: 'campaign',
	global: 'global'
};

const locale = {
	ru: {
		novostnik: 'паркованный новостник',
		campaign: 'кампания',
		global: 'глобальный'
	},
	en: types,
	uk: types,
	de: {
		novostnik: 'Newsletter',
		campaign: 'Kampagne',
		global: 'Global'
	},
	vi: types,
	th: {
		novostnik: 'ข่าวที่รออยู่',
		campaign: 'บริษัท',
		global: 'เกี่ยวกับโลก'
	}
};

module.exports = {
	enum: types,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/postback-log-types.js